import { Component, Input, TemplateRef, OnChanges } from '@angular/core';
import { CurriculaService } from '../../services';
import { ToasterService } from 'angular2-toaster';

@Component({
  selector: 'app-add-comment',
  templateUrl: './app-add-comment.component.html',
  styleUrls: ['./app-add-comment.component.scss']
})
export class AppAddCommentComponent implements OnChanges {

  @Input() model: object;
  @Input() users_id: number;
  @Input() public placeholder: string = null;
  public canSave = false;

  constructor(
    private curriculaService: CurriculaService
  ) { }

  ngOnChanges() { }

  changedComment() {
    this.canSave = true;
  }

  saveComment() {
    console.log('Saving comment', this.model);
    this.model['users_id'] = this.users_id;
    let serviceCall;
    if (this.model['events_id']) { serviceCall = this.curriculaService.saveCheckInComment(this.model); }
    if (this.model['applications_id']) { serviceCall = this.curriculaService.saveApplicationComment(this.model); }
    serviceCall.subscribe(result => {
      this.canSave = false;
    })
  }


}
